import * as api from '@api';
import { BASE_PATH } from '@constants';
import Button from '@retracedgmbh/ui-components-lib/Button';
import { useAuth } from '@state/auth';
import { useCompaniesToSwitch } from '@state/companies-to-switch';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useTranslator from '@/hooks/useTranslator';

const SideBarAccount = ({ me, isImpersonating }) => {
  const navigate = useNavigate();
  const { getTranslation } = useTranslator({ page: 'sidebar' });
  const companiesToSwitch = useCompaniesToSwitch(
    state => state.companiesToSwitch,
  );
  const [switchedToCompaniesList, setSwitchedToCompaniesList] = useState(false);

  const { stopImpersonate, companySwitch, meReceived, isAdmin } = useAuth(
    state => ({
      stopImpersonate: state.stopImpersonate,
      companySwitch: state.companySwitch,
      meReceived: state.meReceived,
      isAdmin: state.isAdmin,
    }),
  );

  const handleCompanySelection = async company => {
    companySwitch(
      companiesToSwitch.find(item => item.companyId === company.key),
    );
    await api.backend.meGet().then(response => {
      if (response.status === 200) {
        meReceived(response.data);
        setSwitchedToCompaniesList(false);
      }
    });
    navigate('/', { replace: true });
  };

  if (!me) return <div />;

  if (switchedToCompaniesList) {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '8px',
            justifyContent: 'space-between',
          }}
        >
          {companiesToSwitch.length > 0 ? (
            <Button
              onClick={() => setSwitchedToCompaniesList(false)}
              color='primary'
            >
              {getTranslation('sidebar.account.back')}
            </Button>
          ) : null}
        </div>

        {companiesToSwitch.map(company => (
          <button
            key={company.companyId}
            type='button'
            className='navbar-item tw:font-bold tw:py-1 tw:mt-2 tw:mb-2'
            onClick={() => {
              handleCompanySelection(company);
            }}
          >
            <span
              className='tw:ml-2 ellipsis'
              style={{ maxWidth: '130px', whiteSpace: 'normal' }}
            >
              {company.name}
            </span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px',
          justifyContent: 'space-between',
        }}
      >
        <span>
          <b>{getTranslation('sidebar.account.account')}</b>
        </span>
        {companiesToSwitch.length > 0 ? (
          <Button
            onClick={() => setSwitchedToCompaniesList(true)}
            color='primary'
          >
            {getTranslation('sidebar.account.switchAccount')}
          </Button>
        ) : null}
      </div>

      {me.company?.id && (
        <button
          type='button'
          className='navbar-item tw:font-bold tw:py-1'
          onClick={() => {
            if (!me.company?.id) return;
            const url = isAdmin()
              ? `${BASE_PATH.COMPANY_MANAGEMENT}/${me.company.id}/view`
              : `/companies/${'TEST'}/view`;
            navigate(url);
            window.location.reload();
          }}
        >
          <figure className='tw:w-24 tw:h-24'>
            <img
              className='tw:rounded-full'
              alt={me.company?.name || ''}
              src={`${
                me?.company?.featuredImageFileUrl ||
                `${import.meta.env.VITE_CDN_URI}/static/dashboard-service/image-404.jpg`
              }?fit=crop&h=96&w=96${isImpersonating ? '&border=48,55FF0000' : ''}`}
            />
          </figure>

          <span
            className='tw:ml-2 ellipsis'
            style={{ maxWidth: '130px', whiteSpace: 'normal' }}
          >
            {me.company?.name}
          </span>
        </button>
      )}

      <button
        type='button'
        className='navbar-item tw:font-bold tw:py-1 tw:mt-2 tw:mb-2'
        onClick={() => {
          navigate(isAdmin() ? '/management/profile/edit' : '/profile/view');
        }}
      >
        <figure className='tw:w-16 tw:h-16'>
          <img
            className='tw:rounded-full'
            alt={getTranslation('sidebar.account.myProfile')}
            src={`${
              me?.avatarFileUrl ||
              `${import.meta.env.VITE_CDN_URI}/static/dashboard-service/image-404.jpg`
            }?fit=crop&h=64&w=64&auto=format${isImpersonating ? '&border=48,55FF0000' : ''}`}
          />
        </figure>

        <span className='tw:ml-2'>
          {getTranslation('sidebar.account.myProfile')}
        </span>
      </button>
      <hr className='navbar-divider tw:my-0 tw:mb-2' />

      {isImpersonating ? (
        <button
          type='button'
          className='navbar-item tw:font-bold'
          id='profile-action-end-impersonate'
          onClick={() => {
            stopImpersonate();
            navigate('/management/impersonate', { replace: true });
          }}
        >
          {getTranslation('sidebar.account.endImpersonate')}
        </button>
      ) : (
        <button
          type='button'
          className='navbar-item tw:font-bold'
          id='profile-action-logout'
          onClick={() => {
            navigate('/logout');
          }}
        >
          <span className='icon tw:mr-1'>
            <i className='fa-light fa-sign-out tw:text-base' />
          </span>
          {getTranslation('sidebar.account.logout')}
        </button>
      )}
    </div>
  );
};

export default SideBarAccount;
